// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__gMq+i","nav":"menu_nav__eExZJ"};